import { render, staticRenderFns } from "./VerifyFamilyMemberEmail.vue?vue&type=template&id=074eee5a"
import script from "./VerifyFamilyMemberEmail.vue?vue&type=script&lang=js"
export * from "./VerifyFamilyMemberEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports